import React, { Component } from 'react';
import './Component.css';
import NeighborhoodMap from './NeighborhoodMap/NeighborhoodMap.jsx';
import ReadMore from './ReadMore/ReadMore.jsx';
import { getText } from './AllTexts.jsx';

class ScaleNeighborhood extends Component {
	render() {
		let text;
		if (this.props.city === 'vancouver') {
			text = getText('scale-neighborhood-intro-vancouver');
		} else if (this.props.city === 'toronto') {
			text = getText('scale-neighborhood-intro-toronto');
		}
		return (
			<div className="Scale-Neighborhood Component" id="neighborhood">
				<div className="text">
					<p className="title">{getText('scale-neighborhood-title')}</p>
					{text}
				</div>
				<div className="graphic">
					<NeighborhoodMap
						updateUrl={this.props.updateUrl}
						scale={this.props.scale}
						city={this.props.city}
						variables={this.props.params.variables}
						update={this.props.update}
						mode={this.props.params.mode}
					/>
				</div>
			</div>
		);
	}
}

export default ScaleNeighborhood;



// WEBPACK FOOTER //
// ./src/ScaleNeighborhood.jsx